export interface SpitexFaqItem {
  question: string;
  answer: string;
}

export const supplyFaqItems: SpitexFaqItem[] = [
  {
    question: 'Welche Qualifikationen brauche ich fuer die Spitex?',
    answer:
      'Fuer die Spitex werden verschiedene Qualifikationsstufen gesucht: Dipl. Pflegefachperson HF oder BSc Pflege FH fuer die volle Pflegeverantwortung, FaGe EFZ fuer Grundpflege und Vitalzeichen, FaBe EFZ fuer Betreuungsaufgaben, AGS EBA fuer Unterstuetzungsarbeiten, sowie Pflegehilfe SRK fuer einfache Pflegetaetigkeiten. Auch Quereinsteigende ohne Fachausbildung koennen im Bereich Hauswirtschaft und Begleitung eingesetzt werden.',
  },
  {
    question: 'Wie viel verdiene ich bei der Spitex?',
    answer:
      'Das Gehalt haengt von Ihrer Qualifikation, Erfahrung und dem Kanton ab. Dipl. Pflegefachpersonen HF verdienen zwischen CHF 75,000 und CHF 110,000 pro Jahr, FaGe zwischen CHF 52,000 und CHF 78,000, und AGS zwischen CHF 42,000 und CHF 60,000. In Kantonen wie Zuerich oder Genf liegen die Loehne 5-12% ueber dem Durchschnitt. Nutzen Sie unseren Gehaltsrechner fuer eine individuelle Schaetzung.',
  },
  {
    question: 'Muss ich Nachtschichten arbeiten?',
    answer:
      'In der Spitex sind Nachtschichten deutlich seltener als im Spital oder Pflegeheim. Die meisten Einsaetze finden tagsüber statt. Je nach Organisation und Region kann es Bereitschaftsdienste geben, diese werden aber in der Regel separat verguetet. Sprechen Sie Ihre Praeferenzen im Bewerbungsgespraech an.',
  },
  {
    question: 'Wie flexibel ist die Einsatzplanung?',
    answer:
      'Die Spitex bietet verschiedene Arbeitsmodelle: Vollzeit, Teilzeit, auf Abruf oder nur am Wochenende. Die Einsatzplanung erfolgt in der Regel im Voraus, und Sie haben Mitspracherecht bei der Gestaltung Ihres Arbeitsplans. Viele Fachkraefte schaetzen gerade diese Flexibilitaet im Vergleich zum starren Schichtbetrieb im Spital.',
  },
  {
    question: 'Werden auslaendische Diplome anerkannt?',
    answer:
      'Ja, auslaendische Pflegediplome koennen in der Schweiz anerkannt werden. Die Anerkennung laeuft ueber das Schweizerische Rote Kreuz (SRK) fuer Nicht-EU-Diplome oder die GESDA fuer EU-Diplome. Die Kosten betragen CHF 550-1,000, der Prozess dauert 2-6 Monate. In manchen Faellen sind Ausgleichsmassnahmen erforderlich.',
  },
  {
    question: 'Wie laeuft die Bewerbung ab?',
    answer:
      'Der Bewerbungsprozess ist einfach: 1. Fuellen Sie unser Formular aus (5 Minuten). 2. Wir pruefen Ihr Profil und kontaktieren Sie innerhalb von 48 Stunden. 3. Wir stellen Ihnen passende Einsatzmoeglichkeiten vor. 4. Sie starten Ihren Einsatz bei einer Spitex-Organisation in Ihrem Kanton.',
  },
  {
    question: 'Was sind die Vorteile gegenueber der Arbeit im Pflegeheim?',
    answer:
      'Die Spitex bietet gegenueber dem Pflegeheim mehrere Vorteile: mehr Eigenverantwortung und Autonomie bei der Arbeit, persoenlichere Beziehungen zu den Klientinnen und Klienten, abwechslungsreichere Taetigkeiten, mehr Flexibilitaet bei der Arbeitsplanung, und ein vergleichbares Gehalt. Viele Pflegefachkraefte schaetzen besonders die Moeglichkeit, selbststaendig zu arbeiten.',
  },
];

export const demandFaqItems: SpitexFaqItem[] = [
  {
    question: 'Was kostet Spitex-Pflege?',
    answer:
      'Die Kosten haengen von der Pflegeart ab. Medizinische Pflege (Grundpflege, Behandlungspflege, Abklaerung) wird von der Krankenkasse (KVG) uebernommen. Sie zahlen maximal CHF 15.35 pro Tag als Patientenbeteiligung. Hauswirtschaftliche Hilfe und Begleitdienste sind nicht KVG-gedeckt und kosten je nach Anbieter CHF 35-65 pro Stunde. Nutzen Sie unseren Kostenrechner fuer eine individuelle Schaetzung.',
  },
  {
    question: 'Was zahlt die Krankenkasse?',
    answer:
      'Die obligatorische Grundversicherung (KVG) deckt aerztlich verordnete Pflegeleistungen: Grundpflege (CHF 52.60/Std.), Untersuchung und Behandlung (CHF 63.00/Std.) sowie Abklaerung und Beratung (CHF 76.90/Std.). Die Patientenbeteiligung betraegt maximal CHF 15.35 pro Tag. Die Differenz zwischen Versicherungsleistung und tatsaechlichen Kosten traegt Kanton oder Gemeinde (Restfinanzierung).',
  },
  {
    question: 'Brauche ich ein aerztliches Rezept?',
    answer:
      'Fuer KVG-gedeckte Leistungen (medizinische Pflege, Grundpflege) benoetigen Sie eine aerztliche Verordnung von Ihrem Hausarzt. Diese wird in der Regel alle 3-6 Monate erneuert. Fuer nicht-KVG-Leistungen wie Hauswirtschaft oder Begleitdienste ist kein Rezept noetig.',
  },
  {
    question: 'Wie schnell kann die Pflege beginnen?',
    answer:
      'Nach Eingang Ihrer Anfrage kontaktieren wir Sie innerhalb von 1 Stunde telefonisch. Die Bedarfsabklaerung (Erstbesuch durch eine qualifizierte Pflegefachperson) findet in der Regel innerhalb von 48 Stunden statt. Bei dringenden Faellen (z.B. nach Spitalentlassung) kann die Pflege oft noch am selben Tag beginnen.',
  },
  {
    question:
      'Was ist der Unterschied zwischen oeffentlicher und privater Spitex?',
    answer:
      'Oeffentliche Spitex-Organisationen haben einen kantonalen Versorgungsauftrag und muessen alle Patienten aufnehmen. Sie erhalten oeffentliche Subventionen. Private Spitex-Unternehmen sind flexibler in ihrem Angebot (z.B. 24h-Pflege, Nachtbetreuung) und oft schneller verfuegbar, koennen aber Patienten ablehnen. Die durchschnittlichen Kosten betragen CHF 114/Std. (oeffentlich) bzw. CHF 83/Std. (privat).',
  },
  {
    question: 'Kann ich die Pflegeperson wechseln?',
    answer:
      'Ja, Sie haben das Recht, einen Wechsel der Pflegeperson zu verlangen. Eine gute Beziehung zwischen Klient/in und Pflegefachperson ist wichtig fuer die Pflegequalitaet. Sprechen Sie Ihr Anliegen direkt bei der Spitex-Organisation an. In der Regel wird unkompliziert eine Alternative gefunden.',
  },
  {
    question: 'Wie melde ich mich fuer Spitex an?',
    answer:
      'Die Anmeldung ist einfach: 1. Fuellen Sie unser Formular aus oder rufen Sie uns an. 2. Wir kontaktieren Sie innerhalb einer Stunde. 3. Eine qualifizierte Pflegefachperson fuehrt eine Bedarfsabklaerung bei Ihnen zu Hause durch. 4. Wir organisieren die passende Pflege und klaeren die Kostenuebernahme. Der gesamte Prozess dauert in der Regel 2-3 Tage.',
  },
  {
    question: 'Ist die Vermittlung wirklich kostenlos?',
    answer:
      'Ja. IhrSpitex finanziert sich ueber eine Vermittlungspauschale, die von der Spitex-Organisation getragen wird. Fuer Sie als Patient oder Angehoerige entstehen keine Kosten.',
  },
  {
    question: 'In welchen Kantonen ist IhrSpitex verfuegbar?',
    answer:
      'IhrSpitex vermittelt in sieben Deutschschweizer Kantonen: Zuerich (ZH), Aargau (AG), Bern (BE), Luzern (LU), St. Gallen (SG), Zug (ZG) und Schwyz (SZ). In jedem Kanton arbeiten wir mit geprüften Spitex-Organisationen zusammen. Wenn Sie in einem anderen Kanton Pflege benoetigen, kontaktieren Sie uns trotzdem. Wir koennen oft weiterhelfen.',
  },
];
